import { gql } from "@apollo/client";

export const QUERY_GET_SIGN_INFORMED_CONSENT_BY_DOCUMENT = gql`
  query QUERY_GET_SIGN_INFORMED_CONSENT($documentNumber: String) {
    signInformedConsent(where: { documentNumber: { _eq: $documentNumber } }) {
      countryPhone
      created_at
      doctorId
      documentNumber
      documentType
      signature
      id
      name
      phone
      userId
    }
  }
`;
